import { render, staticRenderFns } from "./ConversorPantalla.vue?vue&type=template&id=96c35f76&scoped=true&"
import script from "./ConversorPantalla.vue?vue&type=script&lang=ts&"
export * from "./ConversorPantalla.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96c35f76",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/portal-track3/portal-track3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('96c35f76', component.options)
    } else {
      api.reload('96c35f76', component.options)
    }
    module.hot.accept("./ConversorPantalla.vue?vue&type=template&id=96c35f76&scoped=true&", function () {
      api.rerender('96c35f76', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pantallas/Importar/Conversor/ConversorPantalla.vue"
export default component.exports